import { useState } from 'react';

import { DialogsProvider } from '@work4all/components';
import { CallModalContext } from '@work4all/components/lib/hooks/call-modal/CallModalContext';
import { CallModalProps } from '@work4all/components/lib/hooks/call-modal/CallModalProps';
import { ToniAIProvider } from '@work4all/components/lib/toni-ai/components/ToniAIChatBotProvider';

import { ModuleRightsProvider } from '@work4all/data';

import { CallModal } from '../components/CallModal';

interface CallModalProviderProps {
  children: React.ReactNode;
}

export const CallModalProvider = ({ children }: CallModalProviderProps) => {
  const [callModal, setCallModal] = useState<CallModalProps>();

  return (
    <CallModalContext.Provider value={{ callModal, setCallModal }}>
      <ModuleRightsProvider>
        {(loading) => {
          return loading ? null : (
            <ToniAIProvider>
              <DialogsProvider>
                {callModal && <CallModal {...callModal} />}
                {children}
              </DialogsProvider>
            </ToniAIProvider>
          );
        }}
      </ModuleRightsProvider>
    </CallModalContext.Provider>
  );
};
